import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import React from "react";
import {
  UserCheckIcon,
  SearchIcon,
  GlitterIcon,
  HandShakeIcon,
  ArcDownIcon,
  ArcUpIcon,
  LeftPurple,
  LeftWhite,
  CenterPurple,
  CenterWhite,
  RightPurple,
  RightWhite,
} from "./assets";
import { scrollToTop } from "../../../components/src/utils";
import { navigateToUserProfile } from "../../../components/src/utils/userSlug.web";

const backgrounds = [
  {
    images: [
      { src: CenterPurple, className: "testimonial_card c_purple" },
      { src: CenterWhite, className: "testimonial_card c_white" },
    ],
  },
  {
    images: [
      { src: RightPurple, className: "testimonial_card r_purple" },
      { src: RightWhite, className: "testimonial_card r_white" },
    ],
  },
  {
    images: [
      { src: LeftPurple, className: "testimonial_card l_purple" },
      { src: LeftWhite, className: "testimonial_card" },
    ],
  },
];

export interface ArtistStep {
  icon: string;
  heading: string;
}

interface IBannerInfo {
  id: string;
  type: string;
  attributes: {
    title: string;
    description: string;
    created_at: string;
    updated_at: string;
    image: string;
  };
}

interface ILandingBannersSuccessResponse {
  data: IBannerInfo[];
}

interface ILandingBannersErrorResponse {
  error: string;
}

interface Artist {
  id: string;
  image: string;
  name: string;
  role: string;
}

interface IUser {
  id: string;
  type: string;
  attributes: {
    activated: boolean;
    country_code: string | null;
    email: string;
    first_name: string;
    full_phone_number: string;
    last_name: string;
    type: string | null;
    status: string;
    role_id: string;
    roles: string;
    gender: string | null;
    full_name: string;
    user_image_url: string;
    age: number | null;
    date_of_birth: string | null;
    locations: string | null;
    languages: string[];
    created_at: string;
    updated_at: string;
    unique_auth_id: string;
  };
}

interface ITrendingArtistsSuccessResponse {
  accounts: {
    data: IUser[];
  };
  pagination: {
    current_page: number;
    next_page: number | null;
    total_count: number;
    total_pages: number;
  };
}

interface ITrendingArtistsErrorResponse {
  error: string;
}

interface ITestimonial {
  id: string;
  type: string;
  attributes: {
    name: string;
    designation: string;
    content: string;
    created_at: string;
    updated_at: string;
    profile_image: string;
  };
}

interface ITestimonialsSuccessResponse {
  data: ITestimonial[];
}

interface ITestimonialsErrorResponse {
  error: string;
}

export const GET_ARTISTS_STEPS = [
  {
    icon: UserCheckIcon,
    heading: "Get Registered",
  },
  {
    icon: SearchIcon,
    heading: "Search Talent",
  },
  {
    icon: GlitterIcon,
    heading: "Check Speciality",
  },
  {
    icon: HandShakeIcon,
    heading: "Get Artist",
  },
];
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  isGettingBanners: boolean;
  isGettingArtists: boolean;
  isGettingTestimonials: boolean;
  landingBanners: IBannerInfo[];
  trendingArtists: Artist[];
  testimonials: ITestimonial[];
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class LandingPageController extends BlockComponent<
  Props,
  S,
  SS
> {
  landingBannerApiCallId: string = "";
  trendingArtistsApiCallId: string = "";
  testimonialsApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      isGettingBanners: false,
      isGettingArtists: false,
      isGettingTestimonials: false,
      landingBanners: [],
      trendingArtists: [],
      testimonials: [],
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCalId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    if (responseJson) {
      if (apiRequestCalId === this.trendingArtistsApiCallId) {
        this.handleArtistsApiResponse(responseJson);
      }

      if (apiRequestCalId === this.landingBannerApiCallId) {
        this.handleBannersApiResponse(responseJson);
      }

      if (apiRequestCalId === this.testimonialsApiCallId) {
        this.handleTestimonialsApiResponse(responseJson);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount(): Promise<void> {
    scrollToTop()
    this.getLandingBannersApi();
    this.getTrendingArtistsApi();
    this.getTestimonialsApi();
  }

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  handleUserProfileRedirection = (user: Artist) => {
    const { id, name } = user;
    const [firstName, lastName] = name.split(" ");
    navigateToUserProfile(this.props.navigation, {
        id,
        firstName,
        lastName
      });
  }

  getStepsArrow = (index: number) => {
    if (index === 0 || index === 2) {
      return (
        <div className="down_arrow">
          <img src={ArcDownIcon} alt="Arrow" />
        </div>
      );
    } else if (index === 1) {
      return (
        <div className="up_arrow">
          <img src={ArcUpIcon} alt="Arrow" />
        </div>
      );
    } else return null;
  };

  getBackgroundCards = (index: number) => {
    const backgroundIndex = index % 3;

    return (
      <>
        {backgrounds[backgroundIndex].images.map((image, i) => (
          <img key={i} src={image.src} alt="Card" className={image.className} />
        ))}
      </>
    );
  };

  getLandingBannersApi = () => {
    this.setState({ isGettingBanners: true });
    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.landingBannerApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.landingBannersApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getTrendingArtistsApi = () => {
    this.setState({ isGettingArtists: true });
    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.trendingArtistsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.userListingApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getTestimonialsApi = () => {
    this.setState({ isGettingTestimonials: true });
    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.testimonialsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.testimonialsApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleBannersApiResponse = (
    responseJson: ILandingBannersSuccessResponse | ILandingBannersErrorResponse
  ) => {
    if ("data" in responseJson) {
      const { data } = responseJson;
      this.setState({ landingBanners: data, isGettingBanners: false });
    } else {
      this.setState({ landingBanners: [], isGettingBanners: false });
    }
  };

  handleArtistsApiResponse = (
    responseJson:
      | ITrendingArtistsSuccessResponse
      | ITrendingArtistsErrorResponse
  ) => {
    if ("accounts" in responseJson) {
      const {
        accounts: { data },
      } = responseJson;
      const shuffledArtists = [...data].sort(
        () => crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32 - 0.5
      );
      const trendingArtists = shuffledArtists.slice(0, 5).map((user) => {
        const {
          id,
          attributes: { full_name, user_image_url, roles },
        } = user;
        return {
          id,
          name: full_name,
          image: user_image_url,
          role: roles,
        };
      });

      this.setState({
        trendingArtists,
        isGettingArtists: false,
      });
    } else {
      this.setState({ trendingArtists: [], isGettingArtists: false });
    }
  };

  handleTestimonialsApiResponse = (
    responseJson: ITestimonialsSuccessResponse | ITestimonialsErrorResponse
  ) => {
    if ("data" in responseJson) {
      this.setState({
        testimonials: responseJson.data,
        isGettingTestimonials: false,
      });
    } else {
      this.setState({ testimonials: [], isGettingTestimonials: false });
    }
  };

  handleMoreArtistClick = () => {
    this.handlePageRedirection("Catalogue");
  };
  // Customizable Area End
}
